import { gql, useLazyQuery } from "@apollo/client";
import {
  ListSubCategoryQuery,
  ListSubCategoryQueryVariables,
} from "../generated/graphql";

const LIST_SUB_CATEGORY_QUERY = gql`
  query listSubCategory($input: ListSubCategoryInput!) {
    listSubCategory(input: $input) {
      ok
      err
      subCategories {
        id
        name
      }
    }
  }
`;

export const useListSubCategory = (
  onCompleted?: (data: ListSubCategoryQuery) => void
) => {
  return useLazyQuery<ListSubCategoryQuery, ListSubCategoryQueryVariables>(
    LIST_SUB_CATEGORY_QUERY,
    {
      onCompleted,
      fetchPolicy: "network-only",
    }
  );
};
